import React from "react";
import { observer } from "mobx-react-lite";
import { TailwindModal } from "./TailwindModal";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useStore } from "../helpers";
import { useTranslation } from "react-i18next";

export const ServerError = observer((props: any) => {
    const { aiGentoolStore } = useStore();
    const { server_error } = aiGentoolStore;
    const { t } = useTranslation("fetchFromFacialRecognition");
    const handleScanAgain = () => {
        aiGentoolStore.show_voter_not_found(false);
        aiGentoolStore.show_server_error(false);
        aiGentoolStore.toggle_image_capture_modal(true);
    };

    const handleVoterManually = () => {
        aiGentoolStore.toggle_image_capture_modal(false);
        aiGentoolStore.show_voter_not_found(false);
        aiGentoolStore.toggle_image_match_modal(false);
        aiGentoolStore.show_server_error(false);
    };

    return (
        <>
            <TailwindModal isOpen={server_error}>
                <div className="mx-auto flex h-[85vh] w-full max-w-4xl flex-col items-center justify-center rounded-2xl bg-common-white p-4">
                    <DotLottieReact
                        src="https://lottie.host/ff148078-6190-4445-89ef-aa6aa35e17de/Hf4MrjXJYy.lottie"
                        loop
                        autoplay
                        className={"w-85 h-60 opacity-75"}
                    />

                    <p className="mb-4 text-center text-base font-semibold text-gray-400">
                        {t("face_recognition_not_possible")}
                        <br />
                        {t("try_again_later_maually")}
                    </p>

                    <button
                        className="rounded-lg border border-[#6D4DFF] px-8 py-2 font-medium text-[#6D4DFF] transition-all duration-300 hover:bg-gradient-to-r hover:from-[#6D4DFF] hover:to-[#3A80F4] hover:text-white"
                        onClick={handleVoterManually}
                    >
                        {t("add_voter_manually")}
                    </button>
                    <p
                        onClick={handleScanAgain}
                        className="mt-4 cursor-pointer text-[#7c3aed] underline hover:text-[#6d28d9]"
                    >
                        {t("scan_again")}
                    </p>
                </div>
            </TailwindModal>
        </>
    );
});
